export const imageService = {
  async uploadImage(image: string | ArrayBuffer | null, organizationId: number): Promise<ApiResult<ImageResponse>> {
    return useMyFetch<ImageResponse>(`/api/v1/admin/organizations/${organizationId}/images`, {
      method: 'POST',
      body: { image, organization_id: organizationId },
    });
  },
};
